
export const defaultStyles = {
    white: '#ffffff',
    black: '#000000',
    blue: '#2d4691',
    darkBlue: '#012545',
    lightBlue: '#496f92',
    // yellow: '#F1CC00',
    darkerGrey: '#666666',
    darkGrey: '#a0a9aa',
    grey: '#b3babb',
    lightGrey: '#cdd4d8',
    lighterGrey: '#f2f2f2',
    blueGrey: '#e1e7ec',

    redTransparentLight: 'rgba(255,0,0,0.1)',
    redTransparent: 'rgba(255,0,0,0.3)',
    whiteTransparent: 'rgba(255, 255, 255, 0.2)',

    // New colors
    greyBackground: '#f1f1f1',
    greyWhite: '#FAFAFA',
    greyText: '#6d6d6d',
    greyTitle: '#3d3d3d',
    greyLight: '#d5d6d2',
    greyMedium: '#8b8d8e',
    yellow: '#f1cb00',
    red: '#E30040',
};

// TODO : vérifier si utile
export const separator = {
    borderBottomWidth: '1px',
    // borderBottomColor: defaultStyles.lightGrey,
    borderBottomStyle: 'solid',
    paddingBottom: '20px'
};

export const imagesUrl = {
    int: 'https://grout-calculator.bostik.int.eurelis.info',
    qual: 'https://grout-calculator.bostik.qual.eurelis.info',
    prod: 'https://back.grout-calculator.bostik',
    local: 'localhost:9112',
}
